import React, {useEffect} from 'react';
import PromocionLayout from './PromocionLayout';
import './PromocionLayout.css';

function Promo250705() {
    useEffect(() => {
    document.title = "Gana un evento 360° - ProCam360";
    return () => {
      document.title = "ProCam360 - Renta de Photobooths 360°"; // Título por defecto
    };
  }, []);
  return (
    <PromocionLayout
      titulo="¡Gana un evento 360°!"
      subtitulo="Promoción exclusiva para graduados del Colegio Luz del Tepeyac"
      ctaTitulo="¿Listo para participar?"
      ctaSubtitulo="¡No pierdas esta oportunidad única de ganar un evento 360° completamente gratis!"
      mostrarBotonesSociales={true}
    >
      <h2>Términos y Condiciones – "¡Gana un evento 360°!"</h2>

      <div className="terminos-section">
        <h3>1. Organizador</h3>
        <p>
          La presente promoción es organizada por Proyecto CAM360 (ProCam360).
        </p>
      </div>

      <div className="terminos-section">
        <h3>2. Participantes</h3>
        <p>
          Promoción válida únicamente para graduados del Colegio Luz del
          Tepeyac, Generación 2022-2025.
        </p>
      </div>

      <div className="terminos-section">
        <h3>3. Mecánica para participar</h3>
        <p>
          Para participar, los interesados deberán cumplir con todos los
          siguientes pasos:
        </p>
        <ul>
          <li>
            Seguir a ProCam360 en Facebook e Instagram:
            <ul>
              <li>Facebook: procam360mx</li>
              <li>Instagram: @procam360mx</li>
            </ul>
          </li>
          <li>Dar like al último post de ProCam360.</li>
          <li>Subir una foto de su graduación a su perfil personal.</li>
          <li>
            Usar el hashtag <strong>#GraduadoCLT</strong> en la publicación.
          </li>
          <li>Etiquetar a @procam360mx en la foto.</li>
          <li>La foto con más likes será la ganadora.</li>
        </ul>
      </div>

      <div className="terminos-section">
        <h3>4. Premio</h3>
        <p>
          El participante cuya foto obtenga más likes ganará un evento ProCam360
          gratis en CDMX o área metropolitana.
        </p>
      </div>

      <div className="terminos-section">
        <h3>5. Condiciones adicionales</h3>
        <ul>
          <li>
            Es indispensable que el ganador siga a ProCam360 en ambas redes
            sociales (Facebook e Instagram). Si no cumple este requisito, el
            premio se asignará al siguiente participante con más likes que sí
            cumpla.
          </li>
          <li>
            El premio es intransferible y no canjeable por dinero en efectivo.
          </li>
          <li>
            El evento gratuito solo aplica para CDMX y área metropolitana.
          </li>
        </ul>
      </div>

      <div className="terminos-section">
        <h3>6. Anuncio del ganador</h3>
        <p>
          El ganador será anunciado en las redes sociales oficiales de
          ProCam360.
        </p>
      </div>

      <div className="terminos-section">
        <h3>7. Vigencia</h3>
        <p>
          La promoción es válida únicamente durante el periodo anunciado en la
          publicación.
        </p>
      </div>

      <div className="terminos-section">
        <h3>8. Autorización de uso de imagen</h3>
        <p>
          Al participar, los concursantes autorizan a ProCam360 a utilizar su
          nombre y/o imagen para fines promocionales relacionados con esta
          dinámica, sin compensación adicional.
        </p>
      </div>

      <div className="terminos-section">
        <h3>9. Responsabilidad</h3>
        <p>
          ProCam360 no se hace responsable por problemas técnicos, de conexión o
          cualquier otra situación ajena a la empresa que pueda impedir la
          participación o el reclamo del premio.
        </p>
      </div>

      <div className="terminos-section">
        <h3>10. Aceptación</h3>
        <p>
          La participación en la promoción implica la aceptación total de estos
          términos y condiciones.
        </p>
      </div>

      <div className="terminos-section">
        <h3>11. Modificaciones</h3>
        <p>
          ProCam360 se reserva el derecho de modificar o cancelar la promoción
          en cualquier momento, informando oportunamente a los participantes.
        </p>
      </div>
    </PromocionLayout>
  );
}

export default Promo250705;
